const QA_REGEX = /^(qa|review|local)/;

const getRollupHost = (host) => (QA_REGEX.test(host)
  ? 'qa-rollup.fashionunited.com'
  : 'a-rollup.fashionunited.com');

export default getRollupHost;
